module.exports = __webpack_public_path__ + "paper.dca92f4859db9f9bca50.jpg";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src4156872633/src/src/assets/landing/paper.jpg
// module id = ../../../../../src/assets/landing/paper.jpg
// module chunks = 1